export default "__VITE_ASSET__DJOrqawS__"